import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import router from './router'
import  'amfe-flexible' 
import vueCountryRegionSelect from 'vue-country-region-select'
import './assets/icons/iconfont.css'
Vue.prototype.axios = axios
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(vueCountryRegionSelect)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
